import swal from "sweetalert";
import axiosInstance from "../api";
import { setBrandList, setColorListData, setOccassionList, setSingleBrand, setSingleOccassion, setSingleSize, setSinlgeColor, setSizeListData } from "../../reusableSlice";


export const getAllBrands = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/brands`, { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setBrandList(response?.data?.response))
      } else {
        dispatch(setBrandList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setBrandList([]))
    }
  };

  export const addBrand = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("admin/brands", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/brand")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const getSingleBrand = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/brands/${id}`);
      console.log(response,"responsesdfssfs")
      if (response?.data) {
        dispatch(setSingleBrand(response?.data?.response))
      } else {
        dispatch(setSingleBrand([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSingleBrand([]))
    }
  };

  export const updateOneBrand = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("admin/brands", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/brand")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };



 

  export const deleteOneBrand = (id) => async (dispatch) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.delete(`admin/brands/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      // setLoading(false);
    }
  };



